import * as React from 'react';
import { Helmet } from 'react-helmet';

interface BreadCrumbsSchemaDataProps {
  homeDisplayName?: string;
  homeLink?: string;
  categoryDisplayName?: string;
  categoryLink?: string;
}

const getListElement = (position: number, name: string, item: string) => {
  return {
    '@type': 'ListItem',
    position,
    name,
    item,
  };
};
const getSchemaData = (homeDisplayName: string, homeLink: string, categoryDisplayName: string, categoryLink: string) => {
  return {
    '@context': 'http://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      getListElement(1, homeDisplayName, homeLink),
      getListElement(2, categoryDisplayName, categoryLink),
    ],
  };
};

export const BreadCrumbsSchema: React.FunctionComponent<BreadCrumbsSchemaDataProps> = props => {
  const {
    homeDisplayName, homeLink, categoryDisplayName, categoryLink,
  } = props;
  const schema = homeDisplayName && homeLink && categoryDisplayName && categoryLink ? getSchemaData(homeDisplayName, homeLink, categoryDisplayName, categoryLink) : {};
  return homeDisplayName && homeLink && categoryDisplayName && categoryLink
    ? (
      <Helmet>
        <script title="Breadcrumbs" type="application/ld+json">{JSON.stringify(schema)}</script>
      </Helmet>
    )
    : null;
};
